import { IApplicationState } from '../../types/redux';

export const selectSuburbanRkBackground = (state: IApplicationState) => {
  return state.suburbanRk?.background;
};
